import { SEO } from "../constants/ActionTypes"

const initialState = {}

export default function (state = initialState, action = {} ){
    switch(action.type){
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/seo.js